import axios from '@/request';
import qs from 'qs';

export default {
  async getLists(params: any) {
    return axios.get('app-versions/list', { params });
  },
  async add(params: any) {
    return axios.post('app-versions/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('app-versions/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('app-versions/detail', { params });
  },
  async info(params: any) {
    return axios.get('app-versions/info', { params });
  },
  async notice(params: any) {
    return axios.post('app-versions/notice', qs.stringify(params));
  },
  async appstore(params: any) {
    return axios.get('app-versions/appstore', { params });
  },
  async statistics(params: any) {
    return axios.get('app-versions/statistics', { params })
  }
};
